<script setup lang="ts">
import { i18n } from '@apps/main/modules/localization/localizationSetup';
import {
  useBrowserStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';
import { TransportSelector } from '@apps/main/new-desktop/modules/tranposrtSelector';

import { TransportType } from '@libs/trip-planner-interfaces';

import type { ItineraryStenaUpsellNoTransportSegment } from '../../models';
import { useTripOverviewPageStore } from '../../stores';

import ItineraryTimeline from './ItineraryTimeline.vue';
import AddStenaFerryCardDesktop from './upsell/AddStenaFerryCardDesktop.vue';
import AddStenaFerryCardMobile from './upsell/AddStenaFerryCardMobile.vue';
import ItineraryIcon from './ItineraryIcon.vue';

interface ItineraryStenaUpsellNoTransportSegmentProps {
  segment: ItineraryStenaUpsellNoTransportSegment;
}

const props = defineProps<ItineraryStenaUpsellNoTransportSegmentProps>();

const { t } = i18n.global;

const statsigEventsStore = useStatsigEventsStore();
const tripOverviewPageStore = useTripOverviewPageStore();
const browserStore = useBrowserStore();

function selectTransport(transport: TransportType): void {
  tripOverviewPageStore.selectTransport(props.segment, transport);
}
</script>

<template>
  <ItineraryTimeline :segment-type="props.segment.segmentType">
    <template #icon>
      <ItineraryIcon :segment-type="props.segment.segmentType" />
    </template>
    <template #header>
      <div
        class="itinerary-stena-discount-ferry-upsell-no-transport-segment-header"
      >
        <div class="title">
          <div class="primary">
            {{ $t('planner.transport.upsell.add_transport') }}
          </div>
          <div v-if="!browserStore.isSmallerThan1200px" class="secondary">
            {{ $t('planner.transport.upsell.convinient_and_safe') }}
          </div>
        </div>
        <TransportSelector
          :transport-type="TransportType.None"
          :initial-option="t('planner.transport.other_transports')"
          :disabled="false"
          is-upsell-no-transport
          @select="selectTransport($event)"
          @open="statsigEventsStore.logTripOverviewTransportSelectorOpened"
        />
      </div>
    </template>

    <template #content>
      <AddStenaFerryCardDesktop
        v-if="browserStore.isLargerThan599px"
        @add="selectTransport(TransportType.Ferry)"
      />
      <AddStenaFerryCardMobile
        v-else
        @add="selectTransport(TransportType.Ferry)"
      />
    </template>
  </ItineraryTimeline>
</template>

<style scoped lang="scss">
.itinerary-stena-discount-ferry-upsell-no-transport-segment-header {
  width: 100%;

  display: flex;
  justify-content: space-between;

  .title {
    .primary {
      color: var(--color-neutral-70);
      @include font-label-m-bold;
    }

    .secondary {
      color: var(--color-neutral-70);
      @include font-label-m-light;
      margin-top: var(--spacing-8);
    }
  }
}
</style>
